export default __webpack_public_path__ + "static/media/software.05a4f283.png";